import type { ButtonT } from '@mentimeter/ragnar-ui/button';
import { Button as RagnarButton } from '@mentimeter/ragnar-ui/button';
import { EnablePrefetchLink } from '../../utils/EnablePrefetchLink';

export const Button = EnablePrefetchLink<ButtonT>(RagnarButton);
